import { ClientTypesConstants } from "."

export default {
  WEB: 100,
  SPA: 200,
  MOBILE: 300,
  SERVER: 400
}

export const ClientTypeTitle = (type = '') => {
    switch (type) {
      case ClientTypesConstants.SPA:
        return "SPA"
      case ClientTypesConstants.WEB:
        return "Web"
      case ClientTypesConstants.MOBILE:
        return "Mobile"
      case ClientTypesConstants.SERVER:
        return "Server"
      default:
        return "-"
    }
  }